import mdzColors from '../../assets/scss/mdz_colors.module.scss';
import mdzLogo from "!file-loader!../../assets/img/mdz_logo.svg"

const mdzTheme = {
    institutionName: "Mittelstand-Digital Zentrum Klima.Neutral.Digital",
    abbreviation: "MDZ",
    colors: mdzColors,
    logo: mdzLogo,
    aboutLogo: "https://klima-neutral-digital.de/wp-content/themes/knd/assets/img/logo-mittelstand-digital.png",
    impressum: "https://www.zsw-bw.de/footer/impressum.html",
    dataProtection: "https://klima-neutral-digital.de/fn/datenschutzerklaerung/"
}

export default mdzTheme